import { useRecoilValue } from 'recoil';

import events from './events.json';

import { session } from '../recoil/atoms/session';

export const useTrackEvent = () => {
  const userSession = useRecoilValue(session);

  const trackEvent = (eventName, properties = {}, extras) => {
    if (typeof window === 'undefined' || !window.analytics) {
      console.warn('Segment analytics not available');
      return false;
    }
    // Get the event template string
    let eventString = events[eventName];
    // If extras is provided, replace placeholders accordingly.
    if (extras) {
      // If extras is an object, iterate over its keys to replace each placeholder.
      if (typeof extras === 'object' && extras !== null) {
        Object.keys(extras).forEach((key) => {
          const regex = new RegExp(`\\$\\{${key}\\}`, 'g'); // Match all occurrences of the placeholder
          eventString = eventString.replace(regex, extras[key]);
        });
      } else {
        // Otherwise, assume extras is a single value to replace a default placeholder (e.g., ${tabName})
        eventString = eventString.replace(/\$\{tabName\}/g, extras);
      }
    }

    if (userSession.login_type !== 'Admin') {
      window.analytics.track(
        eventString,
        {
          email: userSession.user.email,
          ...properties
        }
      );
    }
    return true;
  };

  return trackEvent;
};
